import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function DestroyModal({
  additionalContent,
  confirmationText,
  displayText,
  isDestroyDisabled = false,
  isOpen,
  onClose,
  onDestroy,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const onDestroyClick = () => {
    onClose();
    onDestroy();
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton
            color='red'
            disabled={isDestroyDisabled}
            onClick={onDestroyClick}
          >
            {confirmationText}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-8' data-element-name='content'>
        <h2 className='tw-m-0 tw-p-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {displayText}
        </h2>
        {additionalContent}
      </div>
    </ModalBox>
  );
}

DestroyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isDestroyDisabled: PropTypes.bool,
  displayText: PropTypes.string.isRequired,
  confirmationText: PropTypes.string.isRequired,
  additionalContent: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  onDestroy: PropTypes.func.isRequired,
};

DestroyModal.defaultProps = {
  additionalContent: null,
};
